<template>
  <div class="content">
    <div class="row">
      <div class="col-8 ignore-screen">
        <h2 class="font-light">New Course</h2>
      </div>
      <div class="col-4 ignore-screen u-vertical-center u-inline-flex">
        <div class="form-group u-inline u-fill-width u-text-right">
          <router-link :to="{ name: 'course-index' }" class="u-inline">
            <button class="btn-info u-pull-right">
              <i
                class="fa-wrapper fa fa-reply normal-icon pad-right"
                aria-hidden="true"
                ></i>
              Index
            </button>
          </router-link>
        </div>
      </div>
    </div>
    <!-- Create Course Form -->
    <server-error v-bind:error="error.serverError"></server-error>
    <div class="form-section">
      <label class="font-bold">Candidate</label>
      <div class="section-body row u-no-padding">
        <div class="col-12">
          <multiselect
            v-model="form.candidate"
            :options="allOtherUsers"
            :multiple="true"
            :close-on-select="false"
            label="name"
            :custom-label="getPilotLabel"
            :show-labels="false"
            track-by="id"
            v-bind:class="{ 'input-error': error.candidate }"
          ></multiselect>
          <span class="error">{{ error.candidate }}</span>
        </div>
      </div>
    </div>
    <div class="form-section">
      <label class="font-bold">Course</label>
      <div class="section-body row u-no-padding">
        <div class="col-12">
          <multiselect
            v-model="form.course"
            :options="courseTemplates"
            :custom-label="getCourseLabel"
            track-by="name"
            :close-on-select="true"
            v-bind:class="{ 'input-error': error.course }"
          ></multiselect>
          <span class="error">{{ error.course }}</span>
        </div>
      </div>
    </div>
    <div class="form-section">
      <label class="font-bold">Start Date</label>
      <div class="section-body row u-nopadding">
        <div class="col-12">
          <input
            v-model="form.start_date"
            type="date"
            v-bind:class="{ 'input-error': error.start_date }"
            />
          <span class="error">{{ error.start_date }}</span>
        </div>
      </div>
    </div>
    <div class="panel">
      <button class="btn-primary" v-on:click="save">
        <loading-spinner v-show="saving"></loading-spinner>
        <i class="fa-wrapper fa fa-upload pad-right" v-show="!saving"></i>
        Create
      </button>
    </div>
  </div>
</template>
<style>
.form-section {
  width: 100%;
}
</style>
<script>
import { mapGetters } from "vuex";
import { debounce } from "@/functions/debounce.function";
import Multiselect from "vue-multiselect";
import ServerError from "@/components/ServerError";
import LoadingSpinner from "@/components/LoadingSpinner";
import { getPilotLabel } from "@/functions/getPilotLabel";
import { clearFormFieldErrors } from "@/functions/clearFormFieldErrors";

export default {
  name: "create-course",
  components: {
    Multiselect,
    ServerError,
    LoadingSpinner,
  },
  data: function() {
    return {
      form: {},
      saving: false
    }
  },
  computed: {
    ...mapGetters("auth", ["users", "userProfile", "permissions"]),
    ...mapGetters("core", ["error"]),
    ...mapGetters("courses", ["courseTemplates"]),
    allOtherUsers: function() {
      return this.users.filter(u => u.id != this.userProfile.id);
    }
  },
  watch: {
    form: {
      // Clear errors when the form is changed.
      handler: debounce(function(formFields) {
        clearFormFieldErrors(formFields);
      }, 300),
      deep: true
    }
  },
  methods: {
    getPilotLabel: function(payload) {
      return getPilotLabel(payload);
    },
    getCourseLabel: function(payload) {
      return payload.name
    },
    validate: function() {
      var err = {};
      var isValid = true;
      // Ensure required fields are completed
      let required = [ 'candidate', 'course', 'start_date' ];
      for (let field of required) {
        if (this.form[field] == undefined) {
          err[field] = "This field is required.";
          isValid = false;
        }
      };
      this.$store.commit("core/setError", err);
      return isValid;
    },
    save() {
      this.saving = true;
      // Validate the form
      let isValid = this.validate();
      if (!isValid) {
        this.saving = false;
        return
      };
      var cleanedData = {
        course_id: this.form.course.id,
        start_date: this.form.start_date
      };
      // Work out where to redirect to next
      if (this.form.candidate.length == 1) {
        cleanedData.redirect = "course-detail";
      } else {
        cleanedData.redirect = "course-index";
      };
      // Send the request
      for (let candidate of this.form.candidate) {
        cleanedData.candidate_id = candidate.id,
        this.$store.dispatch("courses/createCourse", cleanedData);
      }
    }
  },
  mounted() {
    this.$store.commit("core/clearErrors");
    this.$store.dispatch("courses/getCourseTemplates");
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
